import { isWorkspaceUserActive } from "@/lib/workspaceTeamLimits";

/** Nombre visible para listados de equipo (name → parte local del correo). */
export function workspaceUserDisplayName(user) {
  const name = String(user?.name || "").trim();
  if (name) return name;
  const email = String(user?.email || "").trim();
  if (email.includes("@")) return email.split("@")[0];
  return "Usuario";
}

/** Miembros operativos del despacho (no titular ni portal comprador). */
export function isWorkspaceAuxiliaryMember(user) {
  if (!user || user.is_admin_owner || user.is_buyer_tenant) return false;
  if (user.is_designer_backdoor) return false;
  if (!isWorkspaceUserActive(user)) return false;
  if (user.role === "revendedor") return false;
  return true;
}

/**
 * Construye filas «Pendientes por auxiliar» desde GET /admin/users.
 * Pendientes reales (Fase 2 backend): por ahora items vacíos y contador 0.
 */
export function buildPendientesPorAuxiliarFromUsers(users = []) {
  return (Array.isArray(users) ? users : [])
    .filter(isWorkspaceAuxiliaryMember)
    .map((u) => ({
      id: u.id,
      nombre: workspaceUserDisplayName(u),
      email: u.email || "",
      despacho_role: u.despacho_role || u.despacho_profile?.despacho_role || "auxiliar",
      pendientes: 0,
      items: [],
      clients_count: u.clients_count ?? 0,
    }))
    .sort((a, b) => a.nombre.localeCompare(b.nombre, "es"));
}

const EMPTY_AUX_REPORT = {
  total: 0,
  pending: 0,
  in_progress: 0,
  overdue: 0,
  done: 0,
  not_applicable: 0,
};

/** Une filas del reporte API con auxiliares registrados (0 tareas si no hay datos). */
export function mergeTasksReportByAuxiliarRows(reportRows = [], auxiliares = []) {
  const byId = new Map();
  for (const aux of auxiliares || []) {
    const id = aux?.id || aux?.assigned_to_user_id;
    if (!id) continue;
    byId.set(id, {
      assigned_to_user_id: id,
      auxiliar_name: aux.nombre || aux.auxiliar_name || workspaceUserDisplayName(aux),
      ...EMPTY_AUX_REPORT,
    });
  }
  for (const row of reportRows || []) {
    const id = row?.assigned_to_user_id;
    if (!id) continue;
    const base = byId.get(id) || {
      assigned_to_user_id: id,
      auxiliar_name: row.auxiliar_name || id,
      ...EMPTY_AUX_REPORT,
    };
    byId.set(id, {
      ...base,
      ...row,
      auxiliar_name: row.auxiliar_name || base.auxiliar_name,
    });
  }
  return [...byId.values()].sort((a, b) =>
    String(a.auxiliar_name || "").localeCompare(String(b.auxiliar_name || ""), "es"),
  );
}
